// src/lib/crisis-resources.ts
//
// Single technical source of truth for the two APPROVED government crisis /
// urgent-help resources (P2.13B human clinical + operations approval).
//
// These are GOVERNMENT resources, deliberately kept OUT of clinicIdentity:
// they are not ReACH contact methods and must never be rendered inside the
// clinic's contact lists or booking surfaces.
//
// Approved set is exactly these two numbers. Adding any other resource (or
// an alternate number) requires a new P2.13-style clinical + operations
// approval first.
//
// Verified: 2026-08-27
// Source: Government of India ERSS (112 Emergency Response Support System)
// Source: DGHS / Ministry of Health & Family Welfare — Tele-MANAS,
//         National Mental Health Programme
//
// NO ANALYTICS: neither this module nor its consumers may attach any
// tracking to these links. A call to an emergency or mental-health support
// number is sensitive health behavior and must never reach GA4/Ads.

export interface CrisisResource {
  /** Human-readable service name (not necessarily rendered). */
  name: string
  /** The number exactly as displayed to visitors. */
  displayNumber: string
  /** Real tel: destination. */
  href: string
}

export const EMERGENCY_112: CrisisResource = {
  name: 'Emergency Response Support System (India)',
  displayNumber: '112',
  href: 'tel:112',
}

export const TELE_MANAS: CrisisResource = {
  name: 'Tele-MANAS',
  displayNumber: '14416',
  href: 'tel:14416',
}
